import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  isPaymentValid: null,
  defaultPaymentMethodSuccess: null,
  defaultPaymentMethod: null,
  activeProductType: null,
});

const reducer = (state = initState(), action) => {
  switch (action.type) {
    case DispatchConstants.DEFAULT_PAYMENT_SUCCESS:
      return { ...state, defaultPaymentMethod: action.payload, defaultPaymentMethodSuccess: true };
    case DispatchConstants.DEFAULT_PAYMENT_FAIL:
      return { ...state, defaultPaymentMethodSuccess: false };
    default:
  }
  return state;
};

export default reducer;
